"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASH_PAYMENT_METHODS = exports.VOUCHER_PAYMENT_METHODS = exports.PaymentMethodName = exports.TransactionType = exports.TRANSACTION_TYPE_CASH_CORRECTION_LOSS = exports.TRANSACTION_TYPE_CASH_TRANSFER = exports.TRANSACTION_TYPE_TAX = exports.TRANSACTION_TYPE_CASH_CORRECTION_GAIN = exports.TRANSACTION_TYPE_PAYMENT_FEE_USER = exports.TRANSACTION_TYPE_TICKET = exports.TRANSACTION_TYPE_REFUND = exports.TRANSACTION_TYPE_DISCOUNT = exports.TRANSACTION_TYPE_PAYMENT = void 0;
// Payment methods names used in accounting entities from the database
const METHOD_UNKNOWN = 'UNKNOWN';
const METHOD_PENDING = 'PENDING';
const METHOD_PROMO_CODE = 'PROMO_CODE';
const METHOD_VOUCHER = 'VOUCHER';
const METHOD_GIFT_CARD = 'GIFT_CARD';
const METHOD_MEMBERSHIP = 'MEMBERSHIP';
const METHOD_DISCOUNT = 'DISCOUNT';
const METHOD_MEMBERSHIP_DISCOUNT = 'MEMBERSHIP_DISCOUNT';
const METHOD_EXPERIENCEBANK = 'EXPERIENCEBANK';
const METHOD_INVITATION = 'invitation';
const METHOD_REFUNDED_VOUCHER = 'REFUNDED_VOUCHER';
const METHOD_VISA = 'VISA';
const METHOD_GOOGLEPAY = 'GOOGLEPAY';
const METHOD_MASTERCARD = 'MASTERCARD';
const METHOD_AMEX = 'AMEX';
const METHOD_APPLEPAY = 'APPLEPAY';
const METHOD_APPLEPAY_VISA = 'APPLEPAY_VISA';
const METHOD_APPLEPAY_MASTERCARD = 'APPLEPAY_MASTERCARD';
const METHOD_APPLEPAY_MAESTRO = 'APPLEPAY_MAESTRO';
const METHOD_APPLEPAY_AMEX = 'APPLEPAY_AMEX';
const METHOD_TWINT = 'TWINT';
const METHOD_POST_CARD = 'POSTCARD';
const METHOD_PAYPAL = 'PAYPAL';
const METHOD_POSTFINANCE_EFINANCE = 'POSTEFINANCE';
const METHOD_MAESTRO = 'MAESTRO';
const METHOD_CHINA_UNION_PAY = 'CHINA_UNION_PAY';
const METHOD_IDEAL = 'IDEAL';
const METHOD_BANCONTACT = 'BANCONTACT';
const METHOD_BANCONTACT_MOBILE = 'BANCONTACT_MOBILE';
const METHOD_INVOICE = 'INVOICE';
const METHOD_BANK_TRANSFER = 'BANK_TRANSFER';
const METHOD_FREE = 'FREE';
const METHOD_EXTERNAL_VOUCHER = 'EXTERNAL_VOUCHER';
const METHOD_CASH = 'CASH';
const METHOD_CHEQUE = 'CHEQUE';
const METHOD_CHEQUE_CULTURE = 'CHEQUE_CULTURE';
const METHOD_CHEQUE_VACANCES = 'CHEQUE_VACANCES';
const METHOD_PASS_CULTURE = 'PASS_CULTURE';
const METHOD_COUPON_SPORT = 'COUPON_SPORT';
const METHOD_BON_DE_COMMANDE = 'BON_DE_COMMANDE';
const METHOD_BON_DE_COMMANDE_RECEPTIONNE = 'BON_DE_COMMANDE_RECEPTIONNE';
const METHOD_POS_ADYEN = 'POS_ADYEN';
const METHOD_STAND_ALONE_ADYEN = 'STAND_ALONE_ADYEN';
const METHOD_POS_ADYEN_CREATE_ORDER = 'POS_ADYEN_CREATE_ORDER';
const METHOD_POS_ADYEN_PAY_BY_LINK = 'POS_ADYEN_PAY_BY_LINK';
const METHOD_KIOSK_ADYEN = 'KIOSK_ADYEN';
const METHOD_POS_CARD = 'POS_CARD';
const METHOD_POS_CASH = 'POS_CASH';
const METHOD_POS_TWINT = 'POS_TWINT';
const METHOD_POS_INVOICE = 'POS_INVOICE';
const METHOD_POS_BANK_TRANSFER = 'POS_BANK_TRANSFER';
const METHOD_POS_INVITATION = 'POS_INVITATION';
const METHOD_POS_EXTERNAL = 'POS_EXTERNAL';
const METHOD_POS_PROMO_CODE = 'POS_PROMO_CODE';
const METHOD_POS_DISCOUNT = 'POS_DISCOUNT';
const METHOD_POS_VOUCHER = 'POS_VOUCHER';
const METHOD_POS_GIFT_CARD = 'POS_GIFT_CARD';
const METHOD_POS_MEMBERSHIP = 'POS_MEMBERSHIP';
const METHOD_SPONSORED = 'SPONSORED'; // Used for SponsoredValue
// Default methods for other transaction type
const METHOD_TICKET_ONLINE = 'TICKET_ONLINE';
const METHOD_TICKET_POS = 'TICKET_POS';
const METHOD_PAYMENT_FEE_ONLINE = 'PAYMENT_FEE_ONLINE';
const METHOD_TAX = 'TAX';
// Transaction types
exports.TRANSACTION_TYPE_PAYMENT = 1;
exports.TRANSACTION_TYPE_DISCOUNT = 2;
exports.TRANSACTION_TYPE_REFUND = 3; // For logic, try using is refund.
exports.TRANSACTION_TYPE_TICKET = 4;
exports.TRANSACTION_TYPE_PAYMENT_FEE_USER = 5;
exports.TRANSACTION_TYPE_CASH_CORRECTION_GAIN = 8;
exports.TRANSACTION_TYPE_TAX = 6;
exports.TRANSACTION_TYPE_CASH_TRANSFER = 7;
exports.TRANSACTION_TYPE_CASH_CORRECTION_LOSS = 9;
var TransactionType;
(function (TransactionType) {
    TransactionType[TransactionType["PAYMENT"] = 1] = "PAYMENT";
    TransactionType[TransactionType["DISCOUNT"] = 2] = "DISCOUNT";
    TransactionType[TransactionType["REFUND"] = 3] = "REFUND";
    TransactionType[TransactionType["TICKET"] = 4] = "TICKET";
    TransactionType[TransactionType["PAYMENT_FEE_USER"] = 5] = "PAYMENT_FEE_USER";
    TransactionType[TransactionType["TAX"] = 6] = "TAX";
    TransactionType[TransactionType["CASH_TRANSFER"] = 7] = "CASH_TRANSFER";
    TransactionType[TransactionType["CASH_CORRECTION_GAIN"] = 8] = "CASH_CORRECTION_GAIN";
    TransactionType[TransactionType["CASH_CORRECTION_LOSS"] = 9] = "CASH_CORRECTION_LOSS";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var PaymentMethodName;
(function (PaymentMethodName) {
    PaymentMethodName["UNKNOWN"] = "UNKNOWN";
    PaymentMethodName["PENDING"] = "PENDING";
    PaymentMethodName["PROMO_CODE"] = "PROMO_CODE";
    PaymentMethodName["VOUCHER"] = "VOUCHER";
    PaymentMethodName["GIFT_CARD"] = "GIFT_CARD";
    PaymentMethodName["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentMethodName["DISCOUNT"] = "DISCOUNT";
    PaymentMethodName["MEMBERSHIP_DISCOUNT"] = "MEMBERSHIP_DISCOUNT";
    PaymentMethodName["EXPERIENCEBANK"] = "EXPERIENCEBANK";
    PaymentMethodName["INVITATION"] = "invitation";
    PaymentMethodName["REFUNDED_VOUCHER"] = "REFUNDED_VOUCHER";
    PaymentMethodName["VISA"] = "VISA";
    PaymentMethodName["GOOGLEPAY"] = "GOOGLEPAY";
    PaymentMethodName["MASTERCARD"] = "MASTERCARD";
    PaymentMethodName["AMEX"] = "AMEX";
    PaymentMethodName["APPLEPAY"] = "APPLEPAY";
    PaymentMethodName["APPLEPAY_VISA"] = "APPLEPAY_VISA";
    PaymentMethodName["APPLEPAY_MASTERCARD"] = "APPLEPAY_MASTERCARD";
    PaymentMethodName["APPLEPAY_MAESTRO"] = "APPLEPAY_MAESTRO";
    PaymentMethodName["APPLEPAY_AMEX"] = "APPLEPAY_AMEX";
    PaymentMethodName["TWINT"] = "TWINT";
    PaymentMethodName["POST_CARD"] = "POSTCARD";
    PaymentMethodName["PAYPAL"] = "PAYPAL";
    PaymentMethodName["POSTFINANCE_EFINANCE"] = "POSTEFINANCE";
    PaymentMethodName["MAESTRO"] = "MAESTRO";
    PaymentMethodName["CHINA_UNION_PAY"] = "CHINA_UNION_PAY";
    PaymentMethodName["IDEAL"] = "IDEAL";
    PaymentMethodName["BANCONTACT"] = "BANCONTACT";
    PaymentMethodName["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethodName["INVOICE"] = "INVOICE";
    PaymentMethodName["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethodName["FREE"] = "FREE";
    PaymentMethodName["EXTERNAL_VOUCHER"] = "EXTERNAL_VOUCHER";
    PaymentMethodName["CASH"] = "CASH";
    PaymentMethodName["CHEQUE"] = "CHEQUE";
    PaymentMethodName["CHEQUE_CULTURE"] = "CHEQUE_CULTURE";
    PaymentMethodName["CHEQUE_VACANCES"] = "CHEQUE_VACANCES";
    PaymentMethodName["PASS_CULTURE"] = "PASS_CULTURE";
    PaymentMethodName["COUPON_SPORT"] = "COUPON_SPORT";
    PaymentMethodName["BON_DE_COMMANDE"] = "BON_DE_COMMANDE";
    PaymentMethodName["BON_DE_COMMANDE_RECEPTIONNE"] = "BON_DE_COMMANDE_RECEPTIONNE";
    PaymentMethodName["POS_ADYEN"] = "POS_ADYEN";
    PaymentMethodName["STAND_ALONE_ADYEN"] = "STAND_ALONE_ADYEN";
    PaymentMethodName["POS_ADYEN_CREATE_ORDER"] = "POS_ADYEN_CREATE_ORDER";
    PaymentMethodName["POS_ADYEN_PAY_BY_LINK"] = "POS_ADYEN_PAY_BY_LINK";
    PaymentMethodName["KIOSK_ADYEN"] = "KIOSK_ADYEN";
    PaymentMethodName["POS_CARD"] = "POS_CARD";
    PaymentMethodName["POS_CASH"] = "POS_CASH";
    PaymentMethodName["POS_TWINT"] = "POS_TWINT";
    PaymentMethodName["POS_INVOICE"] = "POS_INVOICE";
    PaymentMethodName["POS_BANK_TRANSFER"] = "POS_BANK_TRANSFER";
    PaymentMethodName["POS_INVITATION"] = "POS_INVITATION";
    PaymentMethodName["POS_EXTERNAL"] = "POS_EXTERNAL";
    PaymentMethodName["POS_PROMO_CODE"] = "POS_PROMO_CODE";
    PaymentMethodName["POS_DISCOUNT"] = "POS_DISCOUNT";
    PaymentMethodName["POS_VOUCHER"] = "POS_VOUCHER";
    PaymentMethodName["POS_GIFT_CARD"] = "POS_GIFT_CARD";
    PaymentMethodName["POS_MEMBERSHIP"] = "POS_MEMBERSHIP";
    PaymentMethodName["SPONSORED"] = "SPONSORED";
    PaymentMethodName["TICKET_ONLINE"] = "TICKET_ONLINE";
    PaymentMethodName["TICKET_POS"] = "TICKET_POS";
    PaymentMethodName["PAYMENT_FEE_ONLINE"] = "PAYMENT_FEE_ONLINE";
    PaymentMethodName["TAX"] = "TAX";
    // Added for German non cash payments
    PaymentMethodName["NON_CASH"] = "NON_CASH";
})(PaymentMethodName || (exports.PaymentMethodName = PaymentMethodName = {}));
// Voucher payment methods
// This includes vouchers and Gift cards
exports.VOUCHER_PAYMENT_METHODS = [
    METHOD_VOUCHER,
    // METHOD_REFUNDED_VOUCHER,
    // METHOD_EXTERNAL_VOUCHER,
    METHOD_POS_VOUCHER,
    METHOD_GIFT_CARD,
    METHOD_POS_GIFT_CARD,
];
// Cash payments methods
exports.CASH_PAYMENT_METHODS = [METHOD_CASH, METHOD_POS_CASH];
//# sourceMappingURL=accounting.js.map